<template>
  <div class="container">
    <p style="text-align: center; font-weight: 700; font-size: 24px">
      金融助力激发“新动能”
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bankList: [
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.container {
  min-height: 630px;
  margin: 0 auto;
  width: 1860px;
  background-color: #fff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  padding: 0 30px;
  padding-top: 30px;
  .bankList {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    height: auto;
    justify-content: space-between;
    .backInfo {
      display: flex;
      flex-flow: column nowrap;
      width: 49%;
      cursor: pointer;
      box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
      padding: 20px;
      margin-bottom: 20px;
      border-radius: 6px;
      .first {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        .logo {
          width: 80px;
          height: auto;
          display: block;
          margin-right: 16px;
        }
        .name {
          font-size: 26px;
          font-weight: 600;
        }
      }
      .secound {
        margin-top: 20px;
        text-indent: 2em;
        .introduce {
          font-size: 20px;
        }
      }
    }
  }
}
</style>